import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import Feature from "ol/Feature";
import { FeatureType } from "../models/EnumTypes";
import { SAAMAirSpace } from "../models/saamAirSpace";
import { SaamFromDatabase } from "../popup/saamtrafic-import/saamtrafic-import.component";
import { EndpointsService } from "./endpoints.service";
import { ModalControlService } from "./modal-control.service";
import { PointsService } from "./points.service";
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { clone } from "lodash";
import { DynamicTable } from "../popup/dynamic-table/dynamic-table.component";
import { UtilsService } from "./utils.service";
import { ModalConfirmationService } from "./modal-confirmation.service";
import { UiBlockService } from "./ui-block.service";
import { MapService } from "./map.service";


@Injectable({
  providedIn: 'root'
})
export class SaamTrafficService{

  active: boolean = false;
  fullScreenMode: boolean = false;
  saamFilterTableElems : SaamFilterTableElem[]= [];
  constructor(
    private pointsService : PointsService,
    private endpointService: EndpointsService,
    private http: HttpClient,
    private modalService: ModalControlService,
    private popupService : BsModalService,
    private utilsService: UtilsService,
    private modalConfirmation: ModalConfirmationService,
    private uiBlock: UiBlockService,
    private mapService: MapService
    ){

    }
  openWindow(){
    this.active = true;
  }
  fetchAndAddSaamTrafficLayers(isSwitchProject:boolean){
    isSwitchProject? this.uiBlock.startBlock("Adding entities to map..."): false;
    this.http.get(
    this.endpointService.endpointGetAllSAAMTraffic,
    this.endpointService.httpOptions
    ).subscribe((data:SaamFromDatabase[]) =>{
      try{
      data.forEach((saamFromDataBase:SaamFromDatabase )=>{
        this.addSAAMAirSpaceToMap(saamFromDataBase)
      })
      }finally {
        isSwitchProject? this.uiBlock.stopBlock(): false;
      }
    },
    ()=>{isSwitchProject? this.uiBlock.stopBlock(): false;}
    )
  }
  addSAAMAirSpaceToMap(saam: SaamFromDatabase){
    let saamAirSpace: SAAMAirSpace = this.getSAAMAirSpaceFromSaamFromDatabase(saam);
    this.addSAAMAirSpaceToTable(saamAirSpace,true);
    this.pointsService.addSAAMAirSpaceToMap(saamAirSpace);
  }

  reproject(sourceProjection: string) {
    const source = this.pointsService.saamTrafficDensityLayer.childLayers[0].layers[0]
      .olLayer.getSource();
    
    for (const feature of source.getFeatures()) {
      feature.getGeometry().transform(sourceProjection, this.mapService.getMap('map').getView().getProjection().getCode());
    }
  }



  deleteSAAMLayersFromMap(){
    this.pointsService.deleteFromLayers(this.pointsService.saamTrafficDensityLayer.childLayers[0]);
  }
  getSAAMAirSpaceFromSaamFromDatabase(saam: SaamFromDatabase): SAAMAirSpace{
    let saamairspace : SAAMAirSpace = JSON.parse(saam.saamairspacestring);
    saamairspace.Id = saam.id;
    return saamairspace
  }
  addSAAMAirSpaceToTable(saamairspace: SAAMAirSpace,onMap:boolean){
    let tableElem: SaamFilterTableElem = new SaamFilterTableElem();
    tableElem.saamAirspace = saamairspace;
    tableElem.onMap = onMap;
    this.saamFilterTableElems.push(tableElem);
  }
  deleteSAAMAirSpace(){
    let features: Feature[] = this.pointsService.getSelectedFeaturesOfType(FeatureType.SAAMTraffic)
    if(features.length < 1){
      this.modalService.showMesssageModal("Warning", "Select at least 1 SAAM Layer to delete.");
      return;
    }
    if(features.length > 0){
      let id:number = features[0].get('id');
      let selectedFeatures: Feature[] = [];
      this.saamFilterTableElems.forEach(elem=>{
        selectedFeatures.push(features.find(feature => feature.get('id') == elem.saamAirspace.Id));
        }
      );
      const bsModalRef : BsModalRef = this.popupService.show(DynamicTable, {
        backdrop: 'static' // Prevent closing on backdrop click
      });
      bsModalRef.content.entity = "SAAM Traffic";
      bsModalRef.content.type = "Delete";
      bsModalRef.content.selectAllActive = true;
      bsModalRef.content.data = selectedFeatures;
      bsModalRef.content.displayedColumns = this.utilsService.getDynamicTableColumns('SAAM Traffic');
      bsModalRef.content.onClose.subscribe(result => {
        if(result.length>0){
          let ids : number[] = [];
          this.uiBlock.startBlock("Deleting SAAM layers...");
          result.forEach(elem=>{
            ids.push(elem.get("id"));
          });
          this.pointsService.deleteSAAMBulk(ids).subscribe( (results) =>{
            let source =  this.pointsService.saamTrafficDensityLayer.childLayers[0].layers[0].olLayer.getSource();
            result.forEach( feature => {
              let index: number = this.saamFilterTableElems.findIndex((elemTable) => elemTable.saamAirspace.Id == feature.get("id"));
              this.pointsService.deleteSaamAirSpaceFromMap(this.saamFilterTableElems[index].saamAirspace);
              this.pointsService.clearSelectedFeatures();
              this.saamFilterTableElems.splice(index,1);
            });
            this.modalService.showMesssageModal("SAAM Layers", "SAAM Layers deleted with success.");
            this.uiBlock.stopBlock();
          },
          (error) => {
            this.modalService.showMesssageModal("SAAM Layers", "Error deleting SAAM Layers.");
            this.uiBlock.stopBlock();
          })
        }
      });
    }
  }


}
export class SaamFilterTableElem{
  saamAirspace: SAAMAirSpace;
  onMap: boolean;
  isselected: boolean = false;
}
